import { IPlayer, IPlayerApiClient, IPlayerPage, PlayerFilter } from '@cyber-range/cyber-range-api-ctf-player-client';
import { defineStore } from 'pinia';
import { useApiClientStore } from './apiClientStore';
import { useSessionStore } from './sessionStore';
import { useCompetitionStore } from './competitionStore';
import { useEntitlementStore } from './entitlementStore';
import { useTeamStore } from './teamStore';

export const usePlayerStore = defineStore('playerStore', 
{
    state: () =>
    ({
        player: undefined as IPlayer|undefined,

    }),

    getters:
    {
        getCurrentPlayer(state): IPlayer|undefined
        {
            return state.player || undefined;
        },
    },

    actions: 
    {
        setCurrentPlayer(player?:IPlayer): void
        {
            this.player = player;
        },
        async fetchCurrentPlayer(options?:{background:boolean}): Promise<IPlayer|undefined> 
        {
            const identityId = useSessionStore().identity?.id;
            const competitionId = useCompetitionStore().currentCompetition?.id;

            if (!competitionId || !identityId)
            {
                return undefined;
            }


            let client:IPlayerApiClient = options?.background ? useApiClientStore().backgroundPlayerApiClient : useApiClientStore().playerApiClient;
            
            let filter = new PlayerFilter({competitionId: competitionId, userId: identityId});

            let page: IPlayerPage
            try
            {
                page = await client.get(filter);
            }
            catch
            {
                this.setCurrentPlayer();
                return undefined;
            }

            let player = page.items.length > 0 ? page.items[0] : undefined;
            
            this.setCurrentPlayer(player);

            return player;
        },

        async createPlayer(player: IPlayer)
        {
            await useApiClientStore().playerApiClient.create(player);
            await useEntitlementStore().fetchClaims();
            await this.fetchCurrentPlayer(); // Set the new player
            await useTeamStore().fetchMyTeamId();
        }
    }
});